<template>
  <div class="sm:py-12">
    <div v-if="loading" class="flex justify-center items-center sm:py-12">
      <div class="w-12 h-12 rounded-full border-t-2 border-b-2 animate-spin border-primary"></div>
    </div>
    <div v-else class="">
      <div class="overflow-hidden bg-white shadow-sm dark:bg-gray-800 sm:rounded-lg">
        <div class="p-6 text-gray-900 dark:text-gray-100">
          <!-- Average Rating -->
          <div class="mb-8 sm:px-6 lg:px-8">
            <h3 class="mb-2 text-2xl font-bold dark:text-white">Overall Rating for {{ business?.name }}</h3>
            <div class="flex items-center">
              <div class="flex items-center">
                <span class="mr-2 text-4xl font-bold">{{
                  (business?.rating || 0).toFixed(1)
                }}</span>
                <div class="flex">
                  <template v-for="i in 5" :key="i">
                    <StarIcon
                      :class="[
                        'h-6 w-6',
                        i <= (business?.rating || 0) ? 'text-yellow-400' : 'text-gray-300',
                      ]"
                    />
                  </template>
                </div>
              </div>
              <span class="ml-4 text-gray-500 dark:text-gray-400">
                ({{ reviews?.length || 0 }} reviews)
              </span>
            </div>
          </div>

          <!-- Reviews List -->
          <div>
            <ReviewList
              :business="business"
              :reviews="reviews"
              title="Customer Reviews"
              :showViewAll="false"
              :existingReview="existingReview"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, watch } from 'vue'
import { useRoute } from 'vue-router'
import { useAuthStore } from '@/stores/authStore'
import { useReviewStore } from '@/stores/reviewStore'
import { StarIcon } from '@heroicons/vue/24/solid'
import ReviewList from '@/components/review/ReviewList.vue'
import axios from 'axios'
import { storeToRefs } from 'pinia'
import { USER_ROLES } from '@/types'

const route = useRoute()
const authStore = useAuthStore()
const reviewStore = useReviewStore()
const loading = ref(true)

const form = ref({
  rating: 5,
  comment: '',
})

const canReview = computed(() => {
  return authStore.user && authStore.user.role === USER_ROLES.CUSTOMER
})

const { reviews, existingReview, business } = storeToRefs(reviewStore)

onMounted(async () => {
  try {
    const businessId = route.params.id;
    // Fetch reviews for this business using the store
    await reviewStore.getBusinessReviews(businessId)
  } catch (error) {
    console.error('Error in component setup:', error)
  } finally {
    loading.value = false
  }
})

const submitReview = async () => {
  if (!authStore.user) {
    // Redirect to login if not authenticated
    return
  }

  try {
    const businessId = route.params.id
    const newReview = await reviewStore.createReview(businessId, form.value)

    // Reset the form
    form.value.comment = ''
    form.value.rating = 5

    // Update business rating if available in the response
    if (newReview && newReview.business_rating) {
      business.value.rating = newReview.business_rating
    }
  } catch (error) {
    console.error('Error submitting review:', error)
    alert('Failed to submit review. Please try again.')
  }
}
</script>
